import React from "react";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {
    currentFormatter,
    fractionPercentageBarFormatter,
    numberFormatter,
} from "../../../utils/gridFormatters";
import {Card} from "reactstrap";
import { wtAvg } from "../../../utils/math";


const colDefs = [
    {
        "field": "datastore_name",
        "headerName": "Datastore Name",
        "enableRowGroup": true,
    },
    {
        "field": "datastore_id",
        "headerName": "Datastore ID",
        "enableRowGroup": true,
    },
    {
        "field": "vm_name",
        "headerName": "VM Name",
        "enableRowGroup": true,
    },
    {
        "field": "vcenter_name",
        "headerName": "vCenter Name",
        "enableRowGroup": true,
    },
    {
        "field": "datacenter_name",
        "headerName": "Data Center Name",
        "enableRowGroup": true,
    },
    {
        "field": "cluster_name",
        "headerName": "Cluster Name",
        "enableRowGroup": true,
    },
    {
        "field": "esx_host_name",
        "headerName": "ESX Host Name",
        "enableRowGroup": true,
    },
    {
        "field": "days_old",
        "headerName": "Days Old",
        "filter": "agNumberColumnFilter",
        "cellRenderer": currentFormatter,
        "aggFunc": "sum",
        "cellStyle": {
            "textAlign": "right"
        },
        "enableRowGroup": true,
    },
    {
        "field": "overprovisioned",
        "type": "numericColumn",
        "headerName": "Overprovisioned",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
    },
    {
        "field": "used",
        "headerName": "Used",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "aggFunc": "sum",
    },
    {
        "field": "free",
        "headerName": "Free",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "aggFunc": "sum",

    },
    {
        "field": "allocated",
        "headerName": "Allocated",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "aggFunc": "sum",
    },
    {
        "field": "usable",
        "headerName": "Usable",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "aggFunc": "sum",
    },
    {
        "field": "storage_util_pct",
        "headerName": "%Storage Util",
        "type": "numericColumn",
        "enableValue": true,
        "aggFunc": "avg",
        "cellRenderer": fractionPercentageBarFormatter
    },
    {
        "field": "sum_vmdks",
        "headerName": "Sum of VMDKs",
        "filter": "agNumberColumnFilter",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "aggFunc": "sum",
    },
    {
        "field": "vmdk_alloc_pct_used",
        "headerName": "% VMDK Allocation Used",
        "filter": "agNumberColumnFilter",
        "cellRenderer": fractionPercentageBarFormatter,
        "type": "numericColumn",
        "aggFunc": "avg",
    },
    {
        "field": "env_tag",
        "headerName": "Env Tag",
        "hide": true
    },
    {
        "field": "device_name",
        "headerName": "Device Name",
        "hide": true
    },
    {
        "field": "size",
        "headerName": "Datastore Size",
        "aggFunc": "sum",
        "hide": true
    },
    {
        "field": "datastore_used",
        "headerName": "Datastore Used",
        "aggFunc": "sum",
        "hide": true
    },
    {
        "field": "volume_utilization",
        "headerName": "%Volume Util",
        "cellRenderer": fractionPercentageBarFormatter,
        "aggFunc": "avg",
        "hide": true
    },
    {
        "field": "lun_name",
        "headerName": "LUN Name",
        "hide": true
    },
    {
        "field": "lun_iops",
        "headerName": "LUN IOPS",
        "aggFunc": "sum",
        "hide": true
    },
    {
        "field": "lun_latency",
        "headerName": "LUN Latency",
        aggFunc: (params) => wtAvg(params, "lun_latency", "lun_iops"),
        "hide": true
    },
]

export default function VirtualDatastoreMapping({title, context}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    let route = `/api/v6/report/virtual_datastore_mapping_proc?client_id=${client.clientId}&period_id=${periodId}`;
    const [data, {isLoading}] = useDataWithRoute(route);

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>VM Datastore Mapping Report</VsiH4>
            <VsiBubble>
                <Grid
                    data={data.recordset || []}
                    columnDefs={colDefs}
                    isLoading={isLoading}
                />
            </VsiBubble>
        </Card>
    )
}
